import {StudentOnboardingStepModel} from './StudentOnboardingStepModel';

export class StudentOnboardingModel implements IStudentOnboardingModel {
  /** Key for this template */
  id?: string | undefined;
  /** Created by */
  createdByUserId?: string | undefined;
  /** Title of the template */
  title!: string;
  /** Description of the template */
  description?: string | undefined;
  /** If we want this to be the default for new students */
  isDefault?: boolean | undefined;
  /** Steps for this template */
  onboardingSteps!: StudentOnboardingStepModel[];
  /** Disabled */
  isDisabled?: boolean | undefined;
  /** Date last updated */
  dateUpdated?: Date | undefined;

  constructor(data?: IStudentOnboardingModel) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
    if (!data) {
      this.onboardingSteps = [];
    }
  }

  init(Data?: any) {
    if (Data) {
      this.id = Data["id"];
      this.createdByUserId = Data["createdByUserId"];
      this.title = Data["title"];
      this.description = Data["description"];
      this.isDefault = Data["isDefault"];
      if (Array.isArray(Data["onboardingSteps"])) {
        this.onboardingSteps = [] as any;
        for (let item of Data["onboardingSteps"])
          this.onboardingSteps!.push(StudentOnboardingStepModel.fromJS(item));
      }
      this.isDisabled = Data["isDisabled"];
      this.dateUpdated = Data["dateUpdated"] ? new Date(Data["dateUpdated"].toString()) : <any>undefined;
    }
  }

  static fromJS(data: any): StudentOnboardingModel {
    data = typeof data === 'object' ? data : {};
    let result = new StudentOnboardingModel();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data["id"] = this.id;
    data["createdByUserId"] = this.createdByUserId;
    data["title"] = this.title;
    data["description"] = this.description;
    data["isDefault"] = this.isDefault;
    if (Array.isArray(this.onboardingSteps)) {
      data["onboardingSteps"] = [];
      for (let item of this.onboardingSteps)
        data["onboardingSteps"].push(item.toJSON());
    }
    data["isDisabled"] = this.isDisabled;
    data["dateUpdated"] = this.dateUpdated ? this.dateUpdated.toISOString() : <any>undefined;
    return data;
  }
}

export interface IStudentOnboardingModel {
  /** Key for this template */
  id?: string | undefined;
  /** Created by */
  createdByUserId?: string | undefined;
  /** Title of the template */
  title: string;
  /** Description of the template */
  description?: string | undefined;
  /** If we want this to be the default for new students */
  isDefault?: boolean | undefined;
  /** Steps for this template */
  onboardingSteps: StudentOnboardingStepModel[];
  /** Disabled */
  isDisabled?: boolean | undefined;
  /** Date last updated */
  dateUpdated?: Date | undefined;
}